import * as ArgusUtils from "@mnemonic/pure-utils/ArgusUtils";
import type { IEnvConfig } from "@mnemonic/pure-utils/ArgusUtils";

export const initializeTarget = (): IEnvConfig => ArgusUtils.getTargetMeta();
